// Port of api/fuel/app/classes/filter/search/games/filters/query/collection.php
import F from 'offline/filter/constants'
import Enum from 'offline/enum'

var STATUS_KEYS = ['own', 'prevowned', 'fortrade', 'want', 'wanttoplay', 'wanttobuy', 'wishlist', 'preordered', 'hasparts', 'wantparts']

function collectionStatusCount(filter) {
	var count = 0
	var status = (filter && filter.status) || {}

	for (var i = 0; i < STATUS_KEYS.length; i++) {
		if (status[STATUS_KEYS[i]]) count++
	}

	return count
}

export default {
	name: 'collection',
	_source_require: [F.SOURCE_COLLECTION],
	priority: 5,
	require: function() {
		return true
	},
	run: function(config, filter, data, query) {
		var statusCount = collectionStatusCount(filter)
		var status = filter.status || {}
		var includeWhere = []
		var excludeWhere = []
		var i

		if (statusCount > 1 || (statusCount === 1 && status.own !== 1)) {
			for (i = 0; i < STATUS_KEYS.length; i++) {
				var key = STATUS_KEYS[i]
				var field = 'c.' + Enum.collection_status_field[key]

				if (status.merge) {
					if (status[key] === 1) includeWhere.push(['SUM(' + field + ')', '>=', 1])
					if (status[key] === 2) excludeWhere.push(['SUM(' + field + ')', '=', 0])
				} else {
					if (status[key] === 1) includeWhere.push([field, '=', 1])
					if (status[key] === 2) excludeWhere.push([field, '=', 0])
				}
			}

			if (status.merge) {
				if (includeWhere.length) query.havingGroup(status.user ? 'AND' : 'OR', includeWhere)
				if (excludeWhere.length) query.havingGroup('AND', excludeWhere)
			} else {
				if (includeWhere.length) query.whereGroup(status.user ? 'AND' : 'OR', includeWhere)
				if (excludeWhere.length) query.whereGroup('AND', excludeWhere)
			}

			if (filter.threshold && filter.threshold.owners && config.ownerType !== F.OWNER_USER) {
				query.having('SUM(c.collection_own)', '>=', filter.threshold.owners)
			}

			if (filter.owners && filter.owners.length && config.ownerType !== F.OWNER_USER) {
				if (filter.ownersmin) {
					query.where('c.user_id', 'in', filter.owners)
				} else {
					query.where('cu.user_id', 'in', filter.owners)
				}
			}

			if (status.game) {
				for (i = 0; i < STATUS_KEYS.length; i++) {
					if (status[STATUS_KEYS[i]] === 1) {
						query.having('SUM(c.' + Enum.collection_status_field[STATUS_KEYS[i]] + ')', '>', 0)
					}
				}
			}

			return
		}

		if (statusCount === 1 && status.own === 1) {
			if (config.ownerType === F.OWNER_USER) {
				if (status.merge) {
					query.having('SUM(c.collection_own)', '>=', 1)
				} else if (filter.source && filter.source.collection && !filter.source.ratings && !filter.source.plays) {
					query.where('c.collection_own', '=', 1)
				}
			} else {
				query.where('c.collection_own', '=', 1)

				if (filter.owners && filter.owners.length) {
					if (filter.ownersmin) {
						query.where('c.user_id', 'in', filter.owners)
						query.where('c.collection_own', '=', 1)
					} else {
						query.where('cu.user_id', 'in', filter.owners)
						query.where('cu.collection_own', '=', 1)
					}
				} else {
					query.where('c.user_id', 'in', data.users)
				}

				if (filter.threshold && filter.threshold.owners) {
					query.having('COUNT(DISTINCT(c.user_id))', '>=', filter.threshold.owners)
				}
			}
		}
	}
}
